@if (!options.formState?.isPrint) {
  <lui-signature-pad
    [id]="id"
    [formlyAttributes]="field"
    luiSignaturePadDatuUrlControl
    [formControl]="formControl"
    [options]="props.signatureOptions || {}"
    [readonly]="!!props.readonly"
  ></lui-signature-pad>
} @else {
  <div class="tw-border tw-rounded tw-min-h-32">
    <img [src]="formControl.value" />
  </div>
}
